export const REFRESH_COOLDOWN_MS = 5_000;
